export { toTicket } from '../_internal/utils/parseTicketsFromGqlResponse';